module.exports = __webpack_public_path__ + "static/media/Viktor_0.f4386b8f.jpg";